<template>
  <keep-alive :include="this.cachedViews">
    <router-view :key="key" />
  </keep-alive>
</template>
<script>
import KeepAlive from "@/components/KeepAlive/index";
export default {
  name: 'RouteView',
  props: {
    keepAlive: {
      type: Boolean,
      default: true
    }
  },
  components: {
    KeepAlive
  },
  computed: {
    cachedViews () {
      return this.$store.state.tagsView.cachedViews
    },
    key () {
      return this.$route.path
    }
  },
  data () {
    return {}
  },

  render () {
    const { $route: { meta }, $store: { getters }, cachedViews, key } = this

    // 当未开启多标签且当前路由未开启 keepAlive 时，直接渲染不缓存的视图
    if (!getters.multiTab && !meta.keepAlive) {
      return <router-view key={key} />
    }

    // 开启 multiTab 时或 meta.keepAlive 为 true 时，使用 keep-alive 并基于 cachedViews 进行 include 过滤
    return (
      <keep-alive include={cachedViews}>
        <router-view key={key} />
      </keep-alive>
    )
  }
}
</script>
